import { ProductFamiliesThemeSizeConfig } from './types';

const medium: ProductFamiliesThemeSizeConfig = {
  productFamilies: {},
};

export default medium;
